import React from 'react';

import {useSelector} from 'react-redux';

import {accountSettingsSelector} from 'app/settings/api';

interface Props {
  src: string;
  alt?: string;
  className?: string;
  style?: Record<string, string | number>;
}

export const StaticImg = ({src, ...other}: Props): JSX.Element => {
  const staticURL = useSelector(accountSettingsSelector).data!.STATIC_URL;
  return <img src={`${staticURL}${src}`} {...other} />;
};
